namespace $.$$ {

	const { hsla } = $mol_style_func

	$mol_style_define( $shm_hitalama_textarea, {

		$mol_text_code_token: {
			'@': {
				mol_text_code_token_type: {
					'hitalama-value': {
						color: hsla( 210, 60, 50, 1 ),
					},
				},
			},
		},

		'@': {
			mol_textarea_clickable: {
				true: {
					$mol_text_code_token: {
						'@': {
							mol_text_code_token_type: {
								'hitalama-value': {
									cursor: 'pointer',
								},
							},
						},
					},
				},
			},
		},

	} )

}
